// PR-3634 contracts v4 §6.3: TierPlans rules while the Pro trial is locked (IsTrialLocked, coordinator ruling;
// it also covers the gap between EndDate and the job closing the trial). The days-left text is
// getProTrialDaysRemainingText in ProTrialSlice.

export const STARTER_TIER_ID = 1;

// While the trial is locked the account counts as Starter level, so Standard and Pro can be bought and Starter cannot.
export const getEffectiveTierLevel = (isProTrialLocked: boolean, currentLevel: number): number =>
  isProTrialLocked ? STARTER_TIER_ID : currentLevel;

// Pro is not the current plan while it is only a trial.
export const getPlansForDisplay = <T extends { isCurrentPlan?: boolean }>(plans: T[], isProTrialLocked: boolean): T[] =>
  isProTrialLocked && Array.isArray(plans) ? plans.map((plan) => ({ ...plan, isCurrentPlan: false })) : plans;

export const isStarterLockedByTrial = (isProTrialLocked: boolean, planId: number): boolean =>
  isProTrialLocked && planId === STARTER_TIER_ID;
